import { useState, useEffect } from 'react';
import { AdminLogin } from './AdminLogin';
import { AdminDashboard } from './AdminDashboard';

export function AdminApp() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Check if user is already logged in (from localStorage)
    const savedAuth = localStorage.getItem('hotelAdminAuth');
    if (savedAuth) {
      setIsAuthenticated(true);
    }
    setIsLoading(false);
  }, []);

  const handleLogin = (credentials: { username: string; password: string }) => {
    // In a real app, you would validate credentials with your backend
    localStorage.setItem('hotelAdminAuth', JSON.stringify({
      username: credentials.username,
      loginTime: new Date().toISOString(),
    }));
    setIsAuthenticated(true);
  };

  const handleLogout = () => {
    localStorage.removeItem('hotelAdminAuth');
    setIsAuthenticated(false);
  };

  if (isLoading) {
    return (
      <div className="min-h-screen bg-luxury-gradient flex items-center justify-center relative overflow-hidden">
        <div className="absolute inset-0 bg-luxury-pattern opacity-30"></div>
        <div className="relative text-center">
          <div className="w-20 h-20 border-4 border-gold-400 border-t-transparent rounded-full animate-spin mx-auto mb-6 shadow-gold"></div>
          <p className="text-cream-200 text-lg">Loading luxury admin panel...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <AdminLogin onLogin={handleLogin} />;
  }

  return <AdminDashboard onLogout={handleLogout} />;
}